import { Directive, ElementRef, Input, AfterViewInit, OnDestroy } from '@angular/core'
import flatpickr from 'flatpickr'
import { Instance } from 'flatpickr/dist/types/instance'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

@Directive({
  selector: '[mwlFlatpickr]',
  standalone: true,
})
export class DateFormInputDirective implements AfterViewInit, OnDestroy {
  @Input() flatpickrOptions: Record<string, any> = {}
  @Input() onlyFridays = false

  private fp: Instance | null = null

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    setTimeout(() => this.initFlatpickr())
  }

  ngOnDestroy() {
    this.fp?.destroy()
  }

  private initFlatpickr() {
    const config: Record<string, any> = {
      dateFormat: 'Y-m-d',
      locale: Spanish,
      disableMobile: true,
      ...this.flatpickrOptions,
    }

    if (this.onlyFridays) {
      config['enable'] = [
        function (date: Date) {
          return date.getDay() === 5
        },
      ]
    }

    this.fp = flatpickr(this.el.nativeElement, config) as Instance
  }
}
